module.exports = __webpack_public_path__ + "img/slider-horizontal-3.be239337.svg";